// Agrupamentos especiais de especialidade — Fisioterapia e Fonoaudiologia têm
// subespecialidades (Bobath, RTA etc.) que chegam do IW como especialidades
// separadas, mas o usuário quer somá-las numa visão única no painel. Detectado
// por prefixo do nome, então qualquer subespecialidade nova (ex: "Fisioterapeuta
// Respiratória") entra automaticamente no grupo sem precisar mexer aqui. Outras
// especialidades (Enfermagem, Médico, Nutrição, T.O.) não têm grupo e ficam 1:1.
//
// Compartilhado por UploadVisitas.js, VisitasEspecialidadeHub.js e
// DashboardVisitas.js — mudar a regra aqui muda nos três lugares ao mesmo tempo.
// "chaves" = começos possíveis do nome, sem acento e em maiúsculas: casam tanto as
// planilhas manuais ("Fonoaudiólogo") quanto o IW ("Fonoaudiologo(a)", "Fisioterapia Motora").
export const GRUPOS_ESPECIALIDADE = [
  { nome: 'Fisioterapia', prefixo: 'Fisioterapeuta', chaves: ['FISIOTERAP'] },
  { nome: 'Fonoaudiologia', prefixo: 'Fonoaudiólogo', chaves: ['FONOAUDIOLOG'] },
  { nome: 'Enfermagem', prefixo: 'Enfermeiro', chaves: ['ENFERMEIR'] },
  { nome: 'Médico', prefixo: 'Medico', chaves: ['MEDICO'] },
  { nome: 'Terapia Ocupacional', prefixo: 'Terapeuta Ocupacional', chaves: ['TERAPEUTA OCUP', 'TERAPIA OCUP'] },
  { nome: 'Psicologia', prefixo: 'Psicologo', chaves: ['PSICOLOG'] },
];

const semAcento = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().trim();

// Nome de exibição/agrupamento de uma especialidade real. Retorna a própria
// especialidade quando ela não pertence a nenhum grupo.
export function grupoDe(esp) {
  const n = semAcento(esp);
  const g = GRUPOS_ESPECIALIDADE.find(g => g.chaves.some(c => n.startsWith(c)));
  return g ? g.nome : esp;
}

export function isGrupo(nome) {
  return GRUPOS_ESPECIALIDADE.some(g => g.nome === nome);
}

export function getGrupoConfig(nome) {
  return GRUPOS_ESPECIALIDADE.find(g => g.nome === nome) || null;
}
